import { ModalForm } from "modules/app/styles"
import { ModalBody } from "reactstrap"
import { CoverImageWrapper } from "./styles";

const Preset = ({ handleSubmissionOfMedia }) => {
  const presetImages = ['#8BB4F3', '#92ECCD', '#92ECEC', '#A2C3F6', '#a2c6f6', '#BBF3FC', '#EFBACC', '#F5E9DD', '#F7E4EA', '#F9EFE5', '#f67c48', '#F67848', '#fae8d6', '#FFBDA5', '#FFDBDD'];

  return (
    <>
      <ModalBody>
        <ModalForm>
          <div className='title'>Change Cover Image</div>

          <div className='my-auto d-flex flex-column' style={{ height: '90%' }}>
            <div className='font-weight-600 my-4' style={{ fontSize: '1.14rem' }}>Presets (Logo+Cover)</div>
          </div>

          <CoverImageWrapper>
            {presetImages?.map(image => (
              <img
                key={image}
                onClick={() => handleSubmissionOfMedia(false, `preset-${image}`)}
                src={require(`../../../assets/images/preset/${image}.png`)}
                alt="preset" />
            ))}
          </CoverImageWrapper>
        </ModalForm>
      </ModalBody>
    </>
  )
}

export default Preset